"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _CheckCircleOutlined = _interopRequireDefault(require("@foxui/ui-icons-svg/lib/asn/CheckCircleOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _CheckCircleOutlined.default
  }));
};

/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMiA4LjNhMSAxIDAgMDEwIDEuNGwtNiA2YTEgMSAwIDAxLTEuNCAwbC0zLTNhMSAxIDAgMTExLjQtMS40bDIuMyAyLjI5IDUuMy01LjNhMSAxIDAgMDExLjQgMHoiIC8+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxMmExMSAxMSAwIDExMjIgMCAxMSAxMSAwIDAxLTIyIDB6bTExLTlhOSA5IDAgMTAwIDE4IDkgOSAwIDAwMC0xOHoiIGZpbGwtcnVsZT0iZXZlbm9kZCIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(CheckCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'CheckCircleOutlined';
}
var _default = exports.default = RefIcon;